export default __webpack_public_path__ + "static/media/hbs-cbb-2.adfcb5e6.png";